import { formatTime } from 'ifs-utils';

// 状态
export const STATUS_LIST = [
  { label: '启用', type: 'success', value: 'ENABLED' },
  { label: '禁用', type: 'info', value: 'DISABLED' },
];

// 循环机制
export const CYCLIC_TYPE_LIST = [
  // { label: '一次', value: 'ONE_TIME' },
  { label: '每日', value: 'EVERY_DAY' },
  { label: '工作日', value: 'WORKING_DAY' },
];

// 任务类型
export const TASK_LIST = [
  { label: '常规任务', value: 'REGULAR' },
  { label: '突击任务', value: 'URGENT' },
];

// 类型
export const TYPE_LIST = [
  { label: '固定时间', value: 'FIXED_TIME' },
  { label: '固定次数', value: 'FIXED_FREQUENCY' },
  // { label: '立即执行', value: 'IMMEDIATE_EXECUTION' },
];

// 鉴别结果
export const RESULT_TYPE_LIST = [
  { label: '通过', value: 'EXECUTE_SUCCESS' },
  { label: '不通过', value: 'EXECUTE_FAIL' },
  { label: '未操作', value: 'NOT_EXECUTE' },
];

// 操作类型
export const SCENE_CODE_TYPE = {
  RULE_CREATE: '规则创建',
  RULE_UPDATE: '规则更新',
};

export const TABLE_COLUMN = [
  {
    label: '任务名称',
    prop: 'name',
    width: 250,
    'show-overflow-tooltip': true,
  },
  {
    label: '任务类型',
    prop: 'type',
  },
  {
    label: '任务机制',
    prop: 'taskType',
  },
  {
    label: '循环机制',
    prop: 'cyclicType',
  },
  {
    label: '应用成员',
    prop: 'users',
    width: 250,
    'show-overflow-tooltip': true,
    // formatter: (row) => row.users.map((item) => item.bizName).join(','),
  },
  {
    label: '状态',
    prop: 'status',
  },
  {
    label: '更新人',
    prop: 'updateUserName',
  },
  {
    label: '更新时间',
    prop: 'updateTime',
    formatter: (row) => (row.updateTime ? formatTime(row.updateTime, 'YYYY-MM-DD HH:mm:ss') : ''),
    width: 155,
  },
  {
    label: '操作',
    prop: 'action',
    fixed: 'right',
    width: 180,
  },
];

export const LOG_TABLE_COLUMN = [
  {
    label: '姓名',
    prop: 'unifyName',
  },
  {
    label: '手机号码',
    prop: 'mobile',
  },
  {
    label: '卡控类型',
    prop: 'taskType',
  },
  {
    label: '鉴别结果',
    prop: 'status',
  },
  {
    label: '任务时间',
    prop: 'executeTime',
    formatter: (row) => (row.executeTime ? formatTime(row.executeTime, 'YYYY-MM-DD HH:mm:ss') : ''),
    width: 155,
  },
  {
    label: '鉴别时间',
    prop: 'actualExecuteTime',
    formatter: (row) => (row.actualExecuteTime ? formatTime(row.actualExecuteTime, 'YYYY-MM-DD HH:mm:ss') : ''),
    width: 155,
  },
  {
    label: '操作时长',
    prop: 'executeDuration',
  },
  {
    label: 'IP',
    prop: 'ip',
  },
  {
    label: '位置',
    prop: 'province',
    formatter: (row) => `${row.province ? row.province : ''} ${row.city ? row.city : ''}`,
  },
];

export const LOG_PERSON_TABLE_COLUMN = [
  {
    label: '操作时间',
    prop: 'createTime',
    formatter: (row) => (row.createTime ? formatTime(row.createTime, 'YYYY-MM-DD HH:mm:ss') : ''),
    width: 155,
  },
  {
    label: '操作类型',
    prop: 'sceneCode',
    formatter: (row) => SCENE_CODE_TYPE[row.sceneCode] || '-',
  },
  {
    label: '操作明细',
    prop: 'content',
  },
  {
    label: '操作人',
    prop: 'operatorName',
  },
];

export const USER_LIST_TABLE = [
  {
    label: '姓名',
    prop: 'unifyName',
  },
  {
    label: '手机号码',
    prop: 'mobile',
  },
  {
    label: '操作',
    prop: 'action',
    fixed: 'right',
    width: 80,
  },
];
